/**
 * Carrito
 * Una sola pantalla: se listan los productos, se ajusta la cantidad y se pasa
 * a la pasarela de Shopify, que es donde el cliente escribe sus datos una vez.
 */
(function () {
  var root = document.querySelector("[data-t-cko]");
  if (!root) return;

  /* Oculta la cabecera y el pie en el carrito (regla en cart-checkout.css) */
  document.body.classList.add("template-cart");

  if (Number(root.dataset.itemCount || 0) === 0) return;

  /* Cantidad mediante la Cart API */
  root.querySelectorAll("[data-t-cko-qty]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var key = btn.getAttribute("data-t-cko-qty");
      var delta = Number(btn.getAttribute("data-delta") || 0);
      var input = root.querySelector('[data-t-cko-qty-input="' + key + '"]');
      if (!input) return;
      var next = Math.max(0, Number(input.value || 0) + delta);
      var updates = {};
      updates[key] = next;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates: updates }),
      }).then(function () {
        window.location.reload();
      });
    });
  });
})();
